import React, { createContext } from "react"
import Grid from "react-grid-layout"
import { Panels } from "../utils/constants.ts"
import { UserInfo } from "../backend/types/userInfo.ts"


export const LayoutContext = createContext(
    {
        layout: {} as {name: string, config: Grid.Layout[]},
        _setLayout: (() => {}) as (layout: {name: string, config: Grid.Layout[]}) => void,
        setActiveLayout: (() => {}) as (name: string) => void,
        updateLayout: (() => {}) as (name: string, layout: Grid.Layout[]) => void,
        resetLayout: (() => {}) as () => void,
        layoutConfig: { } as UserInfo['layoutConfig'],
        addLayout: (() => Promise.resolve()) as (name: string, layout: Grid.Layout[]) => Promise<void>,
        removeLayout: (() => {}) as (layoutName: string) => void,
        togglePanel: (() => {}) as (panelName: Panels) => void,
        fullSize: false,
        toggleFullSize: (() => {}) as (panelKey: string) => void,
        isFetching: false,
        isPending: false,
        gridRef: {} as React.RefObject<HTMLDivElement>
    }
)
